import { render, staticRenderFns } from "./Banlist.vue?vue&type=template&id=42462cf2&scoped=true"
import script from "./Banlist.vue?vue&type=script&lang=js"
export * from "./Banlist.vue?vue&type=script&lang=js"
import style0 from "./Banlist.vue?vue&type=style&index=0&id=42462cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42462cf2",
  null
  
)

export default component.exports